import AppHeader from 'Components/AppHeader';
import InfoAside from 'Components/InfoAside';
import Menu from 'Components/Menu';
import { FlowColLayoutProps } from './types';
import * as Styled from './styles';

const FlowColLayout = ({
  children,
  className,
  isFlow,
  section,
}: FlowColLayoutProps): JSX.Element => (
  <>
    <AppHeader isFlow={isFlow} />
    <Styled.Container className={className}>
      <Menu section={section} />
      {children}
      <InfoAside />
    </Styled.Container>
  </>
);

export default FlowColLayout;
